import styled from 'styled-components';

export const Header = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;
export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 12px 0;
  color: ${props => props.theme.text.primary};
`;
export const Subtitle = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: ${props => props.theme.text.secondary};
  max-width: 400px;
  margin: 0 auto;
`;
export const BalancePanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.balancePanel};
  border-radius: 20px;
  padding: 24px 32px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  margin-bottom: 24px;
  gap: 32px;
  min-height: 120px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 700px) {
    max-width: 98vw;
    padding: 16px 4vw;
    gap: 24px;
  }
`;
export const BalanceIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: radial-gradient(circle, #23272f 70%, #181c24 100%);
  box-shadow: 0 0 16px #FFD70044;
  ${props => props.theme.type === 'light' ? 'filter: brightness(0.8);' : ''}
`;
export const BalanceInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const BalanceLabel = styled.div`
  color: ${props => props.theme.type === 'light' ? '#222' : 'rgb(153, 153, 153)'};
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;
`;
export const BalanceValue = styled.div`
  color: ${props => props.theme.type === 'light' ? '#111' : '#fff'};
  font-size: 32px;
  font-weight: 700;
  line-height: 1.1;
`;
export const BuyButton = styled.button`
  width: 100%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  background: ${props => props.theme.primary};
  border: none;
  border-radius: 12px;
  padding: 16px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-bottom: 32px;
  &:hover { opacity: 0.9; }
  &:active { opacity: 0.8; }
`; 